<template>
  <v-container class="py-0" grid-list-md text-xs-center style="max-width: 800px;">
    <section>
      <v-layout row wrap >
      
        <div class="bebas-1 pt-3 pb-2" style="color: black; width: 100%; line-height: 1; text-align: center !important">{{name}}, {{title}}</div>
        <hr color="#5872B7" style="width: 100%; margin-right: 40%; margin-left: 40%; margin-top: 10px; margin-bottom: 20px;"/>
        <div style="text-align: center; width: 100%; font-size: 14px; padding-bottom: 20px;">{{description}}</div>
        <v-flex xs6>
          <v-progress-circular :rotate="270" :size="142" :width="20" :value="overallScore" color="#5872B7">
            <!-- <div class="overall-heading">OVERALL</div> -->
            <div class="bebas-1 overall-score">{{overallScore}}</div>
            <div class="bebas-1 total-score">100</div>
          </v-progress-circular>
        </v-flex>
        <v-flex xs6>
          <div style="max-width: 198px;">
            <div style="color: #888888; text-align: left; margin-left: 8px; padding-bottom: 5px; border-bottom: 1px solid #5872b7;">Overall <br> Average <span v-if="avgScore > 0" class="bebas-1" style="float: right; margin-top: -25px;">{{avgScore}}</span></div>
            <div style="color: #888888; text-align: left; margin-left: 8px; padding-top: 5px;">Age Group <br> Average <span v-if="avgScore > 0" class="bebas-1" style="float: right; margin-top: -25px;">{{avgScore - 3}}</span></div>
            <v-menu v-model="menu" :close-on-content-click="true" :nudge-bottom="3" :nudge-right="44" :nudge-width="-90" offset-y transition="slide-y-transition">
              <template v-slot:activator="{ on }">
                <v-btn outline style="height: 40px; width: 97%; color: #5872B7; font-size: 22px !important;" class="bebas-1 px-4 mb-2" v-on="on" small flat light>
                  Share your score
                </v-btn>
              </template>
              <div style="border: 1px solid; border-radius: 0px !important; border-color: #5872B7; background-color: white;">
                <img style="width: 50px; margin-left: 3px; margin-top:4px; cursor: pointer;" @click="share()" src="@/assets/facebook.png">
                <img style="width: 33px; position: absolute; top: 13px; cursor: pointer;" @click="tweet()" src="@/assets/twitter.png">
              </div>
            </v-menu>
          </div>
        </v-flex>

        <div style="margin-bottom: 20px; width: 100%; text-align: center; font-size: 25px; color: #5872b7; letter-spacing: 10px; overflow: hidden;">............................................................................</div>

        <v-flex xs12 style="color: black; line-height: 1;">
          
          <v-layout row wrap >
            <v-flex xs3>
              <img style="height: 56px; margin-top: -10px;" src="@/assets/hydration.svg">
            </v-flex>
            <v-flex xs9>
              <div style="padding-right: 20px !important;">
                <div class="subheading pb-2 mb-0" style="text-align: left;">
                  Hydration 
                  <div style="float: right;">{{scores.hydrationScore}}/50</div>
                </div>
                <v-progress-linear 
                  height="3"
                  class="pt-0 mt-0"
                  :value="scores.hydrationScore * 2"
                  color="#3dabc5">
                </v-progress-linear>
              </div>
            </v-flex>
          </v-layout> 
        </v-flex>
        <v-flex xs12 style="color: black; line-height: 1;">
          <v-layout row wrap >
            <v-flex xs3>
              <img style="height: 56px; margin-top: -10px;" src="@/assets/pores.svg">
            </v-flex>
            <v-flex xs9>
              <div style="padding-right: 20px !important;">
                <div class="subheading pb-2 mb-0" style="text-align: left;">
                  Pores + Congestion 
                  <div style="float: right">{{scores.poresScore}}/25</div>
                </div>
                <v-progress-linear 
                  height="3"
                  class="pt-0 mt-0"
                  :value="scores.poresScore * 4"
                  color="#ffc47f">
                </v-progress-linear>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 style="color: black; line-height: 1;">
          <v-layout row wrap >
            <v-flex xs3>
              <img style="height: 56px; margin-top: -10px;" src="@/assets/tone.svg">
            </v-flex>
            <v-flex xs9>
              <div style="padding-right: 20px !important;">
                <div class="subheading pb-2 mb-0" style="text-align: left;">
                  Tone + Texture 
                  <div style="float: right">{{scores.toneScore}}/25</div>
                </div>
                <v-progress-linear
                  height="3" 
                  class="pt-0 mt-0"
                  :value="scores.toneScore * 4"
                  color="#ef8880">
                </v-progress-linear>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </section>

    
      
    <v-layout class="py-4" justify-center>
      <img class="logo" src="@/assets/arrow.png">
    </v-layout>

    
    <div class="bebas-1 mb-2 pt-0 pb-0 pt-1" style="width: 100%; background-color: black; color: white; font-size:27px !important;">Your personalized regimen</div>

    <section>
      <v-layout row wrap >
        <!-- <div class="bebas-1 pt-2" style="color: #5872B7; width: 100%; text-align: center !important">{{name}}, here's your personalized regimen</div> -->

        

        <!-- <section style="width: 100%;">
          <hr color="#5872B7" class="my-3" style="margin-right: 40%; margin-left: 40%"/>
        </section> -->

     
        <v-flex xs12 class="pt-2">
          <img style="width: 100%; max-width: 600px;" src="@/assets/pyramid.png">
        </v-flex>

        
        <div style="width: 100%; text-align: center; font-size: 14px;">Our Skin Health Pyramid offers simple, easy-to-follow guidelines for building a regimen to suit your skin type.</div>

      
        <v-layout class="py-4" justify-center>
          <img class="logo" src="@/assets/arrow.png">
        </v-layout>


        <v-flex xs12 class="pb-0 pt-3">
      
          {{matchedTriggers}}

          <div class="bebas-1 mb-2 pt-0 pb-0 pt-1" style="width: 100%; background-color: #3dabc5; color: white; font-size:22px !important;">ANNUALLY</div>
          <div class="pb-3" style="text-align: center;" v-for="(t) in annual" :key="t.tag">
            <ul>
              <li>
                <!-- <span class="pr-1 font-weight-medium">{{t.title}}:</span> -->
                <span>{{t.description}}</span>
              </li>
            </ul>
          </div>

          <div class="bebas-1 mb-2 pt-0 pb-0 pt-1" style="width: 100%; background-color: #f0887f; color: white; font-size:22px !important;">MONTHLY / QUARTERLY </div>
          <div class="pb-3" style="text-align: center;">
            <ul>
              <div class="pb-3">
                <span style="font-weight: bold;">We recommend getting on a regular HydraFacial regimen.</span>
              </div>
              <li v-for="(t) in monthly1" :key="t.tag" class="pb-3">
                <!-- <span class="pr-1 font-weight-medium">{{t.title}}:</span> -->
                <span>{{t.description}}</span>
              </li>
              <div v-show="monthly2.length > 0 || monthly3.length > 0" class="pb-3">
                <span style="font-weight: bold;">Personalize your HydraFacial with these enhancements:</span>
              </div>
              <li v-for="(t) in monthly2" :key="t.tag" class="pb-3">
                <!-- <span class="pr-1 font-weight-medium">{{t.title}}:</span> -->
                <span>
                  <span class="monthly-link">
                    <a v-if="t.link" @click="openLink(t.link, 'learn')" target="_blank">{{t.title}} ></a> 
                    <span v-else style="font-style: italic; color: #f0887f;">{{t.title}}</span>
                  </span> <br> 
                  {{t.description}}
                </span>
              </li>
              <li v-for="(t) in monthly3" :key="t.tag" class="pb-3">
                <!-- <span class="pr-1 font-weight-medium">{{t.title}}:</span> -->
                <span>
                  <span class="monthly-link">
                    <a v-if="t.link" @click="openLink(t.link, 'learn')" target="_blank">{{t.title}} ></a> 
                    <span style="font-style: italic; color: #f0887f;" v-else>{{t.title}}</span>
                  </span> <br> {{t.description}}
                </span>
              </li>
              <li v-show="monthly2.length < 1 && monthly3.length < 1" class="pb-3">
                <!-- <span class="pr-1 font-weight-medium">{{t.title}}:</span> -->
                <span>Our boosters enhance your HydraFacial for a more personalized treatment. Talk to your aesthetician to see which one is right for you.</span>
              </li>
            </ul>
          </div>

          <div class="bebas-1 mb-2 pt-0 pb-0 pt-1" style="width: 100%; background-color: #9069ad; color: white; font-size:22px !important;">DAILY / WEEKLY</div>
          <div class="pb-3" style="text-align: center;" v-for="(t) in daily" :key="t.tag">
            <ul  class="daily-bullet">
              <li >
                <!-- <span class="pr-1 font-weight-medium">{{t.title}}:</span> -->
                <span>{{t.description}} 
                  <span class="daily-link" v-if="t.link && t.tag != 'T37'"><br><b>We recommend:</b><br> <a @click="openLink(t.link, 'clean')" target="_blank">HydraFacial CLEAN ></a> </span>
                  <span class="daily-link" v-if="t.link && t.tag == 'T37'"><br><b>We recommend:</b><br> <a @click="openLink(t.link, 'clean')" target="_blank">HydraFacial PROTECT for daytime ></a> </span>
                  <span class="daily-link" v-if="t.link && t.tag == 'T37'"><br><a @click="openLink(t.link, 'clean')" target="_blank">HydraFacial RESTORE at night ></a> </span>
                </span>
              </li>
            </ul>
          </div>
          <div class="pb-3" style="text-align: center;" v-show="daily.length < 1">
            <ul  class="daily-bullet">
              <li>
                <span>You’re doing great! Make sure you keep cleansing and moisturizing daily and exfoliating 2-3 times a week. <br>
                  <b>We recommend:</b>   <br>
                  <a style="font-style: italic; color: #9069ad;" target="_blank" @click="openLink('https://hydrafacial.com/products', 'essentials')">HydraFacial Essentials: CLEANSE, PROTECT and RESTORE ></a>
                </span>
              </li>
            </ul>
          </div>

          <div class="bebas-1 mb-2 pt-0 pb-0 pt-1" style="width: 100%; background-color: #c560a4; color: white; font-size:22px !important;">ALWAYS</div>
          <div class="pb-3" style="text-align: center;" v-for="(t) in always" :key="t.tag">
            <ul class="always-bullet">
              <li>
                <!-- <span class="pr-1 font-weight-medium">{{t.title}}:</span> -->
                <span>{{t.description}} <span v-if="t.link"><br><b>We recommend:</b> <br> <a @click="openLink(t.link, 'protect')" class="always-link" target="_blank">HydraFacial PROTECT ></a></span></span>
              </li>
            </ul>
          </div>
          <div class="pb-0" style="text-align: center;" v-show="always.length < 1">
            <ul>
              <li>
                <span>You're doing great! Keep drinking plenty of water, wearing sunscreen, eating healthy and staying away from cigarettes. Need an SPF recommendation? 
                  <br>
                  <span>
                    <b>We recommend</b> <br>
                    <a class="always-link" target="_blank" @click="openLink('https://hydrafacial.com/products', 'protect')">HydraFacial PROTECT ></a>
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </v-flex>
      </v-layout>
    </section>

    <!-- <section style="width: 100%;">
      <hr color="#5872B7" class="my-3" style="margin-right: 40%; margin-left: 40%"/>
    </section> -->

      
    <v-layout class="py-4" justify-center>
      <img class="logo" src="@/assets/arrow.png">
    </v-layout>



    <v-flex>
      <v-dialog
        v-model="dialog"
        width="500"
        >
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" small style="height: 40px; font-size: 18px !important;" color='#5872B7' class="bebas-1 px-2 mx-0" dark>
            Email your results
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="bebas-1" style="background-color: rgb(88, 114, 183); color: white; margin-top:-20px; padding-bottom: 5px; " primary-title>
            Email Your Results
          </v-card-title>

          <v-card-text>
            <v-form>
              <v-text-field
                v-model="assessment.social.email"
                label="E-mail Address"
                required
                ></v-text-field>
              <span v-if="!isValid" style="color: red;">Please enter a valid email address</span>
              <v-checkbox v-model="assessment.social.emailSubscribe" color="rgb(88, 114, 183)" label="Sign me up to stay up to date on HydraFacial news, deals and events."></v-checkbox>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-on="on"
                   @click="sendEmail"
                   outline 
                   style="height: 40px; color: #5872B7; font-size: 25px !important; margin-top:10px;" 
                   class="bebas-1 px-4  mb-2" 
                   small
                   flat 
                   light>
              Send
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn small style="height: 40px; font-size: 18px !important; margin-left: 12px !important;" color='#5872B7' class="bebas-1 px-2 mx-0" @click="next()" dark>
        {{buttonText}}
      </v-btn>
       
      <div>
        <v-btn style="height: 50px; color: #black;" @click="previous()" class="bebas-1 pl-0 pb-0 mb-0" small flat light>
          <v-icon style="transform: rotate(180deg);" dark class="pr-1">play_arrow</v-icon>
          Back
        </v-btn>
      </div>
    </v-flex>
  </v-container>
</template>

<script>
import db from '@/db';

export default {
  name: 'summaryCard',
  props: {
    assessment: Object,
    scores: Object,
    name: String,
    back: Function,
    date: Date,
    questions: Array
  },
  mounted() {
    this.writeAssessment();
    this.getScoreAverages();
    db.collection('trigger')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.triggers.push(doc.data());
        });
      });
  },
  computed: {
    buttonText: function (){
      return 'Find an aesthetician';
      // if (this.page == 1){
      //   return 'Get your personalized regimen';
      // }
      // // if (this.page == 2){
      // //   return 'Let\'s get to the details'; 
      // // }
      // else{
      //   return 'Find an aesthetician';
      // }

    },
    annual: function(){
      return this.ok.filter(t => t.frequency == 'ANNUALLY');
    },
    monthly: function(){
      let trumpsToRemove = this.trumpTest();
      let mon = this.ok.filter(t => t.frequency == 'MONTHLY / QUARTERLY');
      return mon.filter(item => !trumpsToRemove.includes(item));
    },
    monthly1: function (){
      return this.monthly.filter(item => item.order == 1);
    },
    monthly2: function (){
      return this.monthly.filter(item => item.order == 2);
    },
    monthly3: function (){
      return this.monthly.filter(item => item.order == 3);
    },
    daily: function(){
      return this.ok.filter(t => t.frequency == 'DAILY / WEEKLY');
    },
    always: function(){
      return this.ok.filter(t => t.frequency == 'ALWAYS');
    },
    overallScore: function() {
      return (
        this.scores.hydrationScore +
        this.scores.poresScore +
        this.scores.toneScore
      );
    },
    title: function() {
      if (this.overallScore > 85) {
        return 'Your skin must love you!';
      }
      if (this.overallScore > 70 && this.overallScore <= 85) {
        return 'You’re on the right track! ';
      }
      if (this.overallScore > 59 && this.overallScore <= 70) {
        return 'It’s time to rethink your routine.';
      }
      else {
        return 'Better skin health starts now.';
      }
    },
    description: function() {
      if (this.overallScore > 85) {
        return 'You’re doing a great job, and we have some tips for taking it to the next level.';
      }
      if (this.overallScore > 70 && this.overallScore <= 85) {
        return 'Just a few minor adjustments to your routine can make a big difference. ';
      }
      if (this.overallScore > 59 && this.overallScore <= 70) {
        return 'You"re on the right track but your skin could probably benefit from a regimen refresh.';
      }
      else {
        return 'Your skin health likely needs a jump start – we have some tips to get you on right path.';
      }
    },
    matchedTriggers: function() {
      this.scores.triggers.map(trigger => {
        this.triggers.filter(t => {
          if (t.tag == trigger) {
            this.ok.push(t);
          }
        });
      });
    }
  },
  data() {
    return {
      isValid: true,
      averageScores: [],
      avgScore: 0,
      on: null,
      dialog: false,
      menu: false,
      page: 1,
      ok: [],
      triggers: [],
      hasPersonal: false,
      hasEmail: false
    };
  },
  methods: {

    getScoreAverages(){
      let totalScoreRaw = 0;

      db.collection('scores')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.averageScores.push(doc.data());
          });
        }).finally( () => {
          let count = this.averageScores.length;
          this.averageScores.forEach(score => {
            totalScoreRaw += score.overallScore;
            this.avgScore = (totalScoreRaw/ count).toFixed(0);;
          });
        });

    },

    writeAssessment: function(){

      setTimeout(() => { 

        this.questions.forEach(q => {
          if (q.answer){
            if (q.answer.text){
              this.assessment.answers[q.questionId] = q.answer.text;
            }else {
              this.assessment.answers[q.questionId] = q.answer;
            }
          }
        });
      
        this.$nextTick(() => {
          this.$gtm.trackEvent({
            event: 'AssessmentEnd',
            'overallScore': this.overallScore,
            'hydrationScore': this.scores.hydrationScore,
            'poresScore': this.scores.poresScore,
            'toneScore': this.scores.toneScore,
          });

          this.assessment.name = this.name;
          this.assessment.scores = {
            overallScore: this.overallScore,
            hydrationScore: this.scores.hydrationScore,
            poresScore: this.scores.poresScore,
            toneScore: this.scores.toneScore
          };

          this.annual.forEach(t =>{
            this.assessment.triggers[t.tag] = t.description;
          });
          this.monthly.forEach(t =>{
            this.assessment.triggers[t.tag] = t.description;
          });
          this.monthly1.forEach(t =>{
            this.assessment.triggers[t.tag] = t.description;
          });
          this.monthly2.forEach(t =>{
            this.assessment.triggers[t.tag] = t.description;
          });
          this.monthly3.forEach(t =>{
            this.assessment.triggers[t.tag] = t.description;
          });
          this.daily.forEach(t =>{
            this.assessment.triggers[t.tag] = t.description;
          });
          this.always.forEach(t =>{
            this.assessment.triggers[t.tag] = t.description;
          });

          if (this.assessment.answers != null && JSON.stringify(this.assessment.answers) != '{}'){
            var assessmentRef = db.collection('assessments').doc(this.assessment.assessmentId);

            let setWithMerge = assessmentRef.set(this.assessment, { merge: true });

          }

        });
      
      }, 500);

    },
    openLink: function (link, type) {
      window.open(link, '_blank');
      this.updateInteract(type);
    },
    tweet: function(){
      if(!this.assessment.social.twitter){
        this.assessment.social.twitter = true;
        this.writeAssessment();
        // this.updateInteract('twitter');
      }
            
      this.$gtm.trackEvent({
        event: 'Share',
        'id': this.assessmentId,
        'method': 'Twitter'
      });

      let url = encodeURI('I just got a ' + this.overallScore + '/100 on the HydraFacial Skin Health Assessment. Take the assessment to see how your skin measures up! https://assessment.hydrafacial.com');

      window.open('https://twitter.com/intent/tweet?text=' + url, '_blank');
    },
    share: function (){
      if(!this.assessment.social.facebook){
        this.assessment.social.facebook = true;
        this.writeAssessment();
        // this.updateInteract('facebook');
      }
      FB.ui({
        method: 'share',
        href: 'https://assessment.hydrafacial.com',
        quote: 'I just got a ' + this.overallScore + '/100 on the HydraFacial Skin Health Assessment. Take the assessment to see how your skin measures up!'
        // action_type: 'og.shares',
        // action_properties: JSON.stringify({
        //     object : {
        //         'og:url': 'https://assessment.hydrafacial.com',

        //         'og:title': 'Here my custom title',
        //         'og:description': 'here custom description',
        //         'og:image': 'https://hf.bc.dev/img/intro.a1aa7fd4.jpg'
        //     }
        // })
      },
      function (response) {
        if (response) {

          this.$gtm.trackEvent({
            event: 'Share',
            'id': this.assessmentId,
            'method': 'Facebook'
          });

        }
      });

    },
    sendEmail: function (){
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let regexMatch = re.test(this.assessment.social.email);

      if (regexMatch){
        this.isValid = true;
        let body = {
          'key': 'sWx7JBgn9LEYNRAh54OMgg',
          'template_name': 'hftest',
          'template_content': [{}],
          'message': {
            'subject': 'HydraFacial Skin Health Assessment Results',
            'from_email': 'selfassessment@hydrafacial.com',
            'from_name': 'HydraFacial',
            'to': [{
              'email': this.assessment.social.email,
              // 'name': 'Brian Coleman',
              'type': 'to'
            }],
            'merge': true,
            'merge_language': 'handlebars',
            'global_merge_vars': [
              {
                'name': 'name',
                'content': this.name.toUpperCase()
              },
              {
                'name': 'overall',
                'content': this.overallScore
              },
              {
                'name': 'hydration',
                'content': this.scores.hydrationScore
              },
              {
                'name': 'pores',
                'content': this.scores.poresScore
              },
              {
                'name': 'tone',
                'content': this.scores.toneScore
              },
              {
                'name': 'annual',
                'content': this.annual
              },
              {
                'name': 'monthly1',
                'content': this.monthly1
              },
              {
                'name': 'monthly2',
                'content': this.monthly2
              },
              {
                'name': 'monthly3',
                'content': this.monthly3
              },
              {
                'name': 'daily',
                'content': this.daily
              },
              {
                'name': 'always',
                'content': this.always
              },
              {
                'name': 'avgAge',
                'content': this.avgScore - 3
              },
              {
                'name': 'avg',
                'content': this.always
              },
              {
                'name': 'titleDesc',
                'content': this.title.toUpperCase()
              },
              {
                'name': 'desc',
                'content': this.description
              },
        
            ],
          }
        };

        let endpoint = 'https://mandrillapp.com/api/1.0/messages/send-template.json';


        this.$http.post(endpoint, body)
          .then((result) => {
            this.dialog = false;
            this.writeAssessment();

            this.$gtm.trackEvent({
              event: 'Share',
              'id': this.assessmentId,
              'method': 'Email'
            });
          })
          .catch(function(error) {
            console.error(error);
          });
      } else {
        this.isValid = false;
      }
      
    },
    trumpTest: function (){
      let trumps = this.ok.filter(t => t.weight != null);
      let highest = 0;
      trumps.map(t=> {
        if (t.weight > highest){
          highest = t.weight;
        }
      });
      return trumps.filter(t=> t.weight < highest);
    },
    newGuid: function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    next: function(){
      this.assessment.social.gotAesthetician = true;
      this.writeAssessment();
      // this.updateInteract('aesthetician');

      this.$gtm.trackEvent({
        event: 'Share',
        'id': this.assessmentId,
        'method': 'FindAProvider'
      });
            
      window.open('https://hydrafacial.com/find-a-provider/', '_blank');

      // if (this.page!=2){
        
      //   if(!this.assessment.social.gotPersonalized){
      //     this.assessment.social.gotPersonalized = true;
      //     this.writeAssessment();
      //     // this.updateInteract('personalized');
      //   }
      //   this.page++;
      // }else{
      //   if(!this.assessment.social.gotAesthetician){
      //     this.assessment.social.gotAesthetician = true;
      //     this.writeAssessment();
      //     // this.updateInteract('aesthetician');
      //   }
      //   window.open('https://hydrafacial.com/find-a-provider/', '_blank');
      // }
    },
    previous: function (){
      if (this.page == 1){
        this.back();

      }else{
        this.page--;
      }

    },
    updateInteract: function(type){
      
      var interactDocRef = db.collection('interact').doc('YZrN6Q6kkGTs0iLhBG7N');

      return db.runTransaction(function(transaction) {
        return transaction.get(interactDocRef).then(function(iDoc) {
          if (!iDoc.exists) {
            throw 'Document does not exist!';
          }

          let newCount;

          if (type == 'email'){
            newCount = iDoc.data().emailCount + 1;
            transaction.update(interactDocRef, { emailCount: newCount });
          }
          else if (type == 'facebook'){
            newCount = iDoc.data().facebookCount + 1;
            transaction.update(interactDocRef, { facebookCount: newCount });
          }
          else if (type == 'twitter'){
            newCount = iDoc.data().twitterCount + 1;
            transaction.update(interactDocRef, { twitterCount: newCount });
          }
          else if (type == 'aesthetician'){
            newCount = iDoc.data().aestheticianCount + 1;
            transaction.update(interactDocRef, { aestheticianCount: newCount });
          }
          else if (type == 'personalized'){
            newCount = iDoc.data().personalizedCount + 1;
            transaction.update(interactDocRef, { personalizedCount: newCount });
          }
          else if (type == 'protect'){
            newCount = iDoc.data().protectCount + 1;
            transaction.update(interactDocRef, { protectCount: newCount });
          }
          else if (type == 'clean'){
            newCount = iDoc.data().cleanCount + 1;
            transaction.update(interactDocRef, { cleanCount: newCount });
          }
          else if (type == 'learn'){
            newCount = iDoc.data().learnMoreCount + 1;
            transaction.update(interactDocRef, { learnMoreCount: newCount });
          }
          else if (type == 'essentials'){
            newCount = iDoc.data().essentialsCount + 1;
            transaction.update(interactDocRef, { essentialsCount: newCount });
          }

        });
      }).then(function() {
        
        this.writeAssessment();
      }).catch(function(error) {
        // console.log('Transaction failed: ', error);
      });
    }

  }
};
</script>

<style scoped>
.overall-score{
  position: absolute;
  top: -60px;
  left: -25px;
  font-size: 65px !important;
}
.total-score{
  border-top: 1px solid #5872B7; 
  position: absolute; 
  left: -10px; 
  top: 20px; 
  font-size: 20px !important;
}
.overall-heading{
  position: absolute;
  left: -3px;
  top: -5px;
}

.monthly-link a{
  font-style: italic; 
  color: #f0887f;

}

.daily-link a{
  font-style: italic; 
  color: #9069ad;

}

.always-link {
  font-style: italic; 
  color: #c560a4;

}




ul{
  padding-left: 0px;
  list-style: none;
}

.always-bullet li:before{
  background-color: rgb(197, 96, 164);
  border-radius: 50%;
  content: "";
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 2px;
  height: 5px;
  width: 5px;

}

.daily-bullet li:before{
  background-color: rgb(144, 105, 173);
  border-radius: 50%;
  content: "";
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 2px;
  height: 5px;
  width: 5px;
}
</style>
